import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { usePerfilCliente } from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets-clientes.actions';
import { CustomTabPanel } from '@/shared/components/ui';

import TabInfoGeneral from '../components/TabInfoGeneral';
import TabDatosTecnicos from '../components/TabDatosTecnicos';
import TabHistorialTickets from '../components/TabHistorialTickets';
import TabFinanciero from '../components/TabFinanciero';
import TabTrazabilidad from '../components/TabTrazabilidad';

export default function PerfilClientePage() {
  const { clienteId } = useParams();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  const { data: clienteData, isLoading } = usePerfilCliente(clienteId || '');

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Volver
        </Button>
        <Typography variant="h5" fontWeight="bold">
          {(clienteData as any)?.nombre_completo || 'Perfil del Cliente'}
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
          <Tab label="Info General" />
          <Tab label="Datos Tecnicos" />
          <Tab label="Historial Tickets" />
          <Tab label="Financiero" />
          <Tab label="Trazabilidad" />
        </Tabs>
      </Box>

      <CustomTabPanel value={tabValue} index={0}>
        <TabInfoGeneral clienteData={clienteData} />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <TabDatosTecnicos clienteData={clienteData} />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={2}>
        <TabHistorialTickets clienteId={Number(clienteId)} />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={3}>
        <TabFinanciero clienteData={clienteData} />
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={4}>
        <TabTrazabilidad
          clienteId={Number(clienteId)}
          contratoId={(clienteData as any)?.contrato_id ?? 0}
        />
      </CustomTabPanel>
    </Paper>
  );
}
